import { render, staticRenderFns } from "./tools.vue?vue&type=template&id=4ccb0db6&scoped=true&"
import script from "./tools.vue?vue&type=script&lang=ts&"
export * from "./tools.vue?vue&type=script&lang=ts&"
import style0 from "./tools.vue?vue&type=style&index=0&id=4ccb0db6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccb0db6",
  null
  
)

export default component.exports